import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Slider, { BackgroundImageSlide } from 'base/components/Slider';
import Flex from 'base/components/Flex';
import theme from 'theme';
import { Branding } from 'base/containers/AppHeader/AppHeader';
import img1 from 'assets/images/login/img1.jpg';
import img2 from 'assets/images/login/img2.jpg';
import img3 from 'assets/images/login/img3.jpg';
import img4 from 'assets/images/login/img4.jpg';
import img5 from 'assets/images/login/img5.jpg';
import img6 from 'assets/images/login/img6.jpg';
import img7 from 'assets/images/login/img7.jpg';
import img8 from 'assets/images/login/img8.jpg';

const ImageSlider = () => (
  <Slider>
    <BackgroundImageSlide src={img1} />
    <BackgroundImageSlide src={img2} />
    <BackgroundImageSlide src={img3} />
    <BackgroundImageSlide src={img4} />
    <BackgroundImageSlide src={img5} />
    <BackgroundImageSlide src={img6} />
    <BackgroundImageSlide src={img7} />
    <BackgroundImageSlide src={img8} />
  </Slider>
);

const SliderWrapper = styled.div`
  display: none;
  @media (min-width: ${theme.breakpoints.desktop}) {
    display: flex;
    flex-grow: 1;
    height: 100vh;
  }
`;

const Main = styled.div`
  padding: 25px;
  width: 400px;
  border-right: 1px solid ${theme.colors.light};
  background: #fff;
  ${(props) => props.variant === 'large' && css`
      width: 50%;
      max-width: 800px;
  `}
  @media (min-width: ${theme.breakpoints.desktop}) {
      height: 100vh;
      overflow: scroll;
  } 
`;

const SplashScreen = ({ variant, children }) => (
  <Flex flexDirection="row">
    <Main variant={variant}>
      <Branding style={{ margin: '-25px -25px 50px -25px' }} />
      {children}
    </Main>
    <SliderWrapper>
      <ImageSlider />
    </SliderWrapper>
  </Flex>
);
SplashScreen.propTypes = {
  variant: PropTypes.oneOf(['default', 'large']),
};
SplashScreen.defaultProps = {
  variant: 'default',
};

export default SplashScreen;
